export default 'Terms and Conditions SA'
